import React from 'react'
import PageLayout from 'layouts/PageLayout'
import EmptyHeader from 'containers/EmptyHeader'
import LoadingState from 'components/LoadingState'
import Footer from 'components/Footer'

export const LoadingPage = () => (
  <PageLayout header={<EmptyHeader hideLogo />} footer={<Footer />}>
    <LoadingState />
  </PageLayout>
)
